import { render, staticRenderFns } from "./CtaCptCodes.vue?vue&type=template&id=18f048af&scoped=true&"
import script from "./CtaCptCodes.vue?vue&type=script&lang=js&"
export * from "./CtaCptCodes.vue?vue&type=script&lang=js&"
import style0 from "./CtaCptCodes.vue?vue&type=style&index=0&id=18f048af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f048af",
  null
  
)

export default component.exports